import { TranslationObject } from '@/types/language';

const spanishTranslations: TranslationObject = {
  // Home Screen
  'welcome': 'Bienvenido al Museo',
  'select_tour': 'Seleccionar un recorrido',
  'search_exhibit': 'Buscar una exposición',
  'visitor_info': 'Información para visitantes',
  
  // Tour Selection
  'available_tours': 'Recorridos disponibles',
  'view_all_tours': 'Ver todos los recorridos',
  
  // Exhibit Access
  'exhibit_access': 'Acceder a una exposición',
  'enter_number': 'Introducir número de exposición',
  'scan_qr': 'Escanear código QR',
  'view_map': 'Ver en el mapa',
  'browse_exhibits': 'Explorar exposiciones',
  'keypad': 'Teclado',
  'browse_tours': 'Explorar recorridos',
  
  // Exhibit Detail
  'add_to_favorites': 'Añadir a favoritos',
  'remove_from_favorites': 'Eliminar de favoritos',
  'share': 'Compartir',
  'previous': 'Anterior',
  'next': 'Siguiente',
  'audio_guide': 'Guía de audio',
  'more_info': 'Más información',
  
  // Favorites
  'favorites': 'Favoritos',
  'no_favorites': '¡Todavía no hay favoritos. Añade exposiciones mientras exploras!',
  
  // Visitor Info
  'opening_hours': 'Horario de apertura',
  'getting_here': 'Cómo llegar',
  'contact': 'Contáctenos',
  'important_links': 'Enlaces importantes',
  
  // Accessibility
  'accessibility': 'Accesibilidad',
  'font_size': 'Tamaño de fuente',
  'font_size_normal': 'Normal',
  'font_size_large': 'Grande',
  'font_size_extra_large': 'Muy grande',
  'high_contrast': 'Alto contraste',
  'language': 'Idioma',
  'select_language': 'Seleccionar idioma',
  'accessibility_menu': 'Opciones de accesibilidad',
  'toggle_high_contrast': 'Alternar modo de alto contraste',
  'audio_controls': 'Controles de audio',
  'playback_speed': 'Velocidad de reproducción',
  'volume': 'Volumen',
  'auto_play_audio': 'Reproducción automática de audio',
  'toggle_auto_play': 'Alternar reproducción automática',
  
  // Navigation
  'home': 'Inicio',
  'tours': 'Recorridos',
  'exhibits': 'Exposiciones',
  'info': 'Info',
  'map': 'Mapa',
  'list': 'Lista',
  
  // General
  'loading': 'Cargando...',
  'error': 'Algo salió mal',
  'back': 'Atrás',
  'play': 'Reproducir',
  'pause': 'Pausar',
  
  // Search related translations
  'search': 'Buscar...',
  'no_results': 'No se encontraron resultados',
  
  // Welcome Message
  'welcome_message': 'Bienvenido a la aplicación de audioguía del Museo Agam. Puede explorar nuestras exposiciones ingresando un número usando el teclado, o navegar a través de recorridos seleccionados desde el menú.',
};

export default spanishTranslations;
